export default __webpack_public_path__ + "static/showerHead@2x-20748b14bc98c2479d926c29c4b21c72.png";